import _defineProperty from "@babel/runtime/helpers/defineProperty";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import { useLocation, useNavigate } from 'react-router-dom';
import queryparse from 'tricks/string/queryparse';
import createLocation from 'utils/createLocation';

// the parameters needed to fetch asset data from the server

// A hook that listens for the url-query to contain a parameter 'asset' and then displays it.
function useAssetViewerQueryParams(assetParamName) {
  var location = useLocation();
  var navigate = useNavigate();
  var search = location.search;
  var _queryparse = queryparse(search),
    assetId = _queryparse[assetParamName],
    isPublished = _queryparse.isPublished,
    playlistId = _queryparse.playlistId;
  var params = {
    isPublished: isPublished && isPublished !== 'false',
    playlistId: playlistId && +playlistId,
    assetId: assetId && +assetId
  };
  function removeQueryParams() {
    navigate(createLocation(location, _defineProperty({
      playlistId: undefined,
      isPublished: undefined
    }, assetParamName, undefined)), {
      replace: true
    });
  }
  return [params, removeQueryParams];
}
export default useAssetViewerQueryParams;